import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { fetchPendingFeedback } from '@/entities/feedback-item';
import { submitFeedbackAction } from '@/features/submit-feedback';
import { ApiError } from '@/shared/api';
import { uiCopy, feedbackKindLabel } from '@/shared/copy';
import { Alert, AlertDescription, AlertTitle, Button, Sheet, Skeleton, } from '@/shared/ui';
export function PendingFeedbackList() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selected, setSelected] = useState(null);
    const [busy, setBusy] = useState(false);
    const [comment, setComment] = useState('');
    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await fetchPendingFeedback();
            setItems(data.items);
        }
        catch (err) {
            setError(err instanceof ApiError ? err.message : uiCopy.loadFailed);
        }
        finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        void load();
    }, [load]);
    if (loading)
        return _jsx(Skeleton, { className: "h-64 w-full" });
    return (_jsxs("div", { className: "space-y-4", children: [error ? (_jsxs(Alert, { variant: "destructive", children: [_jsx(AlertTitle, { children: uiCopy.errorTitle }), _jsx(AlertDescription, { children: error })] })) : null, items.length === 0 ? (_jsxs(Alert, { children: [_jsx(AlertTitle, { children: "\u0412\u0441\u0435 \u043E\u0442\u0437\u044B\u0432\u044B \u0437\u0430\u043A\u0440\u044B\u0442\u044B" }), _jsx(AlertDescription, { children: "\u041D\u043E\u0432\u044B\u0445 \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432 \u043D\u0430 \u043E\u0431\u0440\u0430\u0442\u043D\u0443\u044E \u0441\u0432\u044F\u0437\u044C \u043D\u0435\u0442." })] })) : null, _jsx("ul", { className: "divide-y divide-border rounded-md border border-border", children: items.map((item) => (_jsx("li", { children: _jsxs("button", { type: "button", className: "flex w-full flex-col gap-1 px-4 py-3 text-left hover:bg-muted/40", onClick: () => {
                            setSelected(item);
                            setComment('');
                        }, children: [_jsx("span", { className: "font-medium", children: item.title }), _jsxs("span", { className: "text-sm text-muted-foreground", children: [item.agentDisplayName, " \u00B7 ", feedbackKindLabel(item.kind)] })] }) }, item.feedbackId))) }), _jsx(Sheet, { open: selected !== null, onClose: () => setSelected(null), title: selected?.title ?? 'ОС', children: selected ? (_jsxs("div", { className: "space-y-3", children: [_jsxs("p", { className: "text-sm", children: ["\u0410\u0433\u0435\u043D\u0442: ", selected.agentDisplayName] }), _jsxs("label", { className: "block text-sm", children: ["\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439", _jsx("textarea", { className: "mt-1 w-full rounded-md border border-input bg-background p-2", rows: 4, value: comment, onChange: (e) => setComment(e.target.value) })] }), _jsx(Button, { type: "button", disabled: busy, onClick: () => {
                                void (async () => {
                                    setBusy(true);
                                    try {
                                        await submitFeedbackAction(selected.feedbackId, {
                                            comment,
                                        });
                                        setSelected(null);
                                        await load();
                                    }
                                    catch (err) {
                                        setError(err instanceof ApiError ? err.message : uiCopy.actionFailed);
                                    }
                                    finally {
                                        setBusy(false);
                                    }
                                })();
                            }, children: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043E\u0442\u0437\u044B\u0432" })] })) : null })] }));
}
